import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, ShieldCheck, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const EMBLEM = "/emblem.png";

function fmt(d) {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("it-IT"); } catch { return d; }
}

export default function VerificaPubblica() {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    axios.get(`${BACKEND}/api/public/verifica/${id}`)
      .then((r) => setState({ loading: false, data: r.data, error: null }))
      .catch(() => setState({ loading: false, data: null, error: "Tesserino non trovato o non valido." }));
  }, [id]);

  const { loading, data, error } = state;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0E281F] px-4 py-10">
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl" data-testid="verifica-card">
        <div className="flex items-center gap-3 bg-[#14382C] px-6 py-5 text-white">
          <img src={EMBLEM} alt="Emblema" className="h-14 w-auto object-contain" />
          <div>
            <p className="text-sm font-bold uppercase leading-tight tracking-wide">Associazione Nazionale Guardie Ecozoofile ODV</p>
            <p className="text-xs text-emerald-100/80">Verifica tesserino</p>
          </div>
        </div>

        <div className="p-6">
          {loading && (
            <div className="flex items-center justify-center gap-2 py-10 text-slate-500">
              <Loader2 className="h-5 w-5 animate-spin" /> Verifica in corso…
            </div>
          )}

          {!loading && error && (
            <div className="flex flex-col items-center gap-3 py-8 text-center" data-testid="verifica-invalid">
              <XCircle className="h-14 w-14 text-red-500" />
              <p className="font-heading text-lg font-bold text-slate-900">Tesserino non valido</p>
              <p className="text-sm text-slate-500">{error}</p>
            </div>
          )}

          {!loading && data && (
            <div>
              <div className={`mb-5 flex items-center gap-3 rounded-xl px-4 py-3 ${data.valido ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`} data-testid="verifica-status">
                {data.valido ? <CheckCircle2 className="h-7 w-7 flex-shrink-0" /> : <XCircle className="h-7 w-7 flex-shrink-0" />}
                <div>
                  <p className="font-bold">{data.valido ? "Tesserino valido e attivo" : "Tesserino non attivo / scaduto"}</p>
                  <p className="text-xs opacity-80">Stato: {data.stato}</p>
                </div>
              </div>

              <p className="font-heading text-2xl font-extrabold text-[#14382C]">{data.cognome} {data.nome}</p>
              <p className="mb-4 flex items-center gap-1.5 text-sm font-semibold text-[#D97706]">
                <ShieldCheck className="h-4 w-4" /> {data.qualifica}
              </p>

              <dl className="space-y-2 text-sm">
                {[["Matricola", data.matricola], ["Tessera", data.numero_tessera], ["Distaccamento", data.distaccamento],
                  ["N. Decreto", data.numero_decreto], ["Scadenza decreto", fmt(data.scadenza_decreto)]].map(([l, v]) => (
                  <div key={l} className="flex justify-between border-b border-dotted border-slate-200 pb-1.5">
                    <dt className="text-slate-400">{l}</dt>
                    <dd className="font-semibold text-slate-900">{v || "—"}</dd>
                  </div>
                ))}
              </dl>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
